import React from "react";
import {
    InsightHtml,
    MetricText,
    Micro,
    SectionHead,
} from "@/features/investors/components/atoms/InvestorsAtoms";
import { InvestorsDashboardData } from "@/features/investors/types/investors.types";
import { InvestorsInsights } from "@/features/investors/utils/investors-insights";
import { investorsFormatters as fmt } from "@/features/investors/utils/investors-formatters";

type Props = {
    data: InvestorsDashboardData;
    insights: InvestorsInsights;
};

export const NetworkSection: React.FC<Props> = ({ data, insights }) => {
    const { contacts } = data;

    return (
        <section className="sec" id="sec-network">
            <SectionHead
                index="08"
                title="Network growth"
                question={
                    <>
                        Question: <em>Is our network expanding?</em>
                    </>
                }
            />
            <div className="grid" style={{ gridTemplateColumns: "repeat(4,1fr)", marginBottom: 20 }}>
                <Micro
                    label="Used in period"
                    value={<MetricText metric={contacts.contactsUsedInPeriod} render={fmt.numShort} />}
                    valueColor="var(--pos)"
                    sub="Distinct contacts on completed operations"
                />
            </div>
            <div style={{ marginTop: 20 }}>
                <InsightHtml html={insights.notes.network} />
            </div>
        </section>
    );
};
